import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { Configuration } from 'remarketing-angular-library';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { TranslocoDirective } from '@jsverse/transloco';
import { CheckIconComponent } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-mark-arrived-success-modal',
    templateUrl: './mark-arrived-success-modal.component.html',
    styleUrls: ['./mark-arrived-success-modal.component.scss'],
    imports: [TranslocoDirective, CheckIconComponent]
})
export class MarkArrivedSuccessComponent implements OnInit {
  private readonly _destroy$ = new Subject();

  configuration: Configuration;

  @Output()
  close = new EventEmitter();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this._destroy$))
      .subscribe(configuration => (this.configuration = configuration));
  }

  closeModal() {
    this.close.emit();
  }
}
